// Tiny in-memory observer bus used by the capture client adapter to
// fan out authoritative events to UI subscribers (Zustand store,
// optional telemetry listeners). No backpressure, no async scheduling
// — handlers run synchronously in registration order. This matches the
// behaviour the Phase-1/2 server-backed adapter (C2.7) and the
// Phase-3 PowerSync adapter will both build on top of, so the bus is
// the one seam shared across both.

import type { CaptureEvent } from '@citycare/shared'

export type CaptureEventHandler = (event: CaptureEvent) => void

export interface CaptureEventBus {
  subscribe(handler: CaptureEventHandler): () => void
  emit(event: CaptureEvent): void
  size(): number
}

export function createCaptureEventBus(): CaptureEventBus {
  const handlers = new Set<CaptureEventHandler>()
  return {
    subscribe(handler) {
      handlers.add(handler)
      return () => {
        handlers.delete(handler)
      }
    },
    emit(event) {
      for (const handler of handlers) {
        handler(event)
      }
    },
    size() {
      return handlers.size
    },
  }
}
